import apiClient from "../../utils/api.client";
import { getNoaId } from "../../utils/session.utils";
import { setAllGameOffersActive } from "../../store/slices/gammaSlice";

const getExistgames = async () => {
  let url = "/game-service/games";
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error at getExistgames EP: ", error);
    throw error;
  }
};

const getGameById = async (gameId) => {
  let url = `/game-service/games/${gameId}`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error at getGameById EP: ", error);
    throw error;
  }
};

const getGameOffers = async (pageNumber, perPage, enabled, sort) => {
  const noaId = getNoaId();
  let criteria = sort?.criteria;
  let field = sort?.field;
  try {
    const url = `/game-service/organizations/${noaId}/gameOffers?pageNumber=${pageNumber}&pageSize=${perPage || 20}&orderCriteria=${criteria || "DESC"}&orderField=${field || "id"}${enabled === "true" ? `&enabled=true` : enabled === "false" ? `&enabled=false` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getGameOffers EP: ", error);
    throw error;
  }
};

const addGames = async (payload) => {
  let url = `/game-service/games`;
  try {
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error(`Error at addGames EP: `, error);
    throw error;
  }
};

const deleteGameMode = async (gameId, modeId) => {
  let url = `/game-service/games/${gameId}/mode/${modeId}`;
  try {
    const response = await apiClient.delete(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.error(`Error at deleteGameMode EP: `, error);
    throw error;
  }
};

const deleteBaseGame = async (gameId) => {
  let url = `/game-service/games/${gameId}`;
  try {
    const response = await apiClient.delete(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.error(`Error at deleteBaseGame EP: `, error);
    throw error;
  }
};

const editGames = async (payload) => {
  let url = `/game-service/games/integrated`;
  try {
    const response = await apiClient.put(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error(`Error at editGames EP: `, error);
    throw error;
  }
};

// NOTE: The payload must contain an object called organization: with the noaOrganization
const newGameOffers = (payload) => {
  let url = `/game-service/gameOffers`;
  try {
    const response = apiClient.post(url, payload);
    const data = response.data;
    return data;
  } catch (error) {
    console.error(`Error at newGameOffers EP: `, error);
    throw error;
  }
};

// NOTE: The payload must contain an object called organization: with the noaOrganization
const updateGameOffers = (payload) => {
  let url = `/game-service/gameOffers`;
  try {
    const response = apiClient.put(url, payload);
    const data = response.data;
    return data;
  } catch (error) {
    console.error(`Error at updateGameOffers EP: `, error);
    throw error;
  }
};

const deleteGameOffers = async (gameId) => {
  const noaId = getNoaId();
  let url = `/game-service/organizations/${noaId}/gameOffers/${gameId}`;
  try {
    const response = await apiClient.delete(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.error(`Error at deleteGameOffers EP: `, error);
  }
};

const searchGame = async (payload, dispatch) => {
  // TODO: There is going to be more than one Telekino?
  let url = `/game-service/games?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=name&name=${payload}`;
  try {
    const response = await apiClient.get(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error(`Error at searchGame EP: `, error);
  }
};

const getAllActivesGameOffers = async (dispatch) => {
  const noaId = getNoaId();

  try {
    const response = await apiClient.get(
      `/game-service/organizations/${noaId}/gameOffers?pageNumber=1&orderCriteria=DESC&orderField=id&enabled=true`,
    );
    const data = response.data;

    if (data.totalElements > 1) {
      try {
        const elements = await apiClient.get(
          `/game-service/organizations/${noaId}/gameOffers?pageNumber=1&pageSize=${data.totalElements}&orderCriteria=DESC&orderField=id&enabled=true`,
        );
        dispatch(setAllGameOffersActive(elements.data.content));
      } catch (error) {
        console.log("From error", error);
        throw error;
      }
    } else {
      dispatch(setAllGameOffersActive(data.content));
    }

    return data;
  } catch (error) {
    console.log("Error at getAllActivesGameOffers", error);
    dispatch(setAllGameOffersActive(error.message));
    dispatch(setAllGameOffersActive(error.message));
    throw error;
  }
};

const getAllGameOffers = async () => {
  const noaId = getNoaId();
  let url = `/game-service/organizations/${noaId}/gameOffers?pageNumber=1&pageSize=1&orderCriteria=DESC&orderField=id`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    console.log("data at getAllGameOffers", data);
    return data;
  } catch (error) {
    console.error(`Error at getAllGameOffers EP: `, error);
  }
};

const getRaffle = async (gameId, modeId, page, pageSize, raffleDate) => {
  let url = `/game-service/games/${gameId}/modes/${modeId}/raffles?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=DESC&orderField=raffleDate${raffleDate ? `&fromRaffleDate=${raffleDate}` : ""} `;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getRaffle EP: ", error);
    throw error;
  }
};

const getAllGames = async () => {
  const noaId = getNoaId();
  try {
    const response = await apiClient
      .get(
        `game-service/organizations/${noaId}/gameOffers?pageNumber=1&pageSize=1&orderCriteria=DESC&orderField=id`,
      )
      .then(async (res) => {
        const data = res.data;
        if (data.totalElements > 1) {
          const elements = await apiClient.get(
            `/game-service/organizations/${noaId}/gameOffers?pageNumber=1&pageSize=${data.totalElements}&orderCriteria=DESC&orderField=id`,
          );
          const content = elements.data;
          return content;
        }
        return data;
      })
      .catch((error) => {
        console.log(error);
      });

    return response;
  } catch (error) {
    console.error("Error at getAllGames EP: ", error);
    throw error;
  }
};

const gamesService = {
  getExistgames,
  getGameById,
  getGameOffers,
  addGames,
  deleteGameMode,
  deleteBaseGame,
  editGames,
  newGameOffers,
  updateGameOffers,
  deleteGameOffers,
  searchGame,
  getAllActivesGameOffers,
  getAllGameOffers,
  getRaffle,
  getAllGames,
};

export default gamesService;
